
<!-- Home Section -->
<section id="home" class="container-fluid home-Section">
  <div class="container content-main text-center">
    <h2 class="main-text">Let’s Uncover Tech Potential For Your Business</h2>
    <!--    <h2 class="main-text">Fighting Covid-19: We are at the forefront</h2>-->
    <!--    <p class="text-center text-white" style=""><a style="text-decoration: none;color: white" routerLink="/insights/fighting-covid-19-we-are-at-the-forefront">Find out more...</a></p>-->
  </div>
</section>
<section class="container-fluid">
  <div class="container py-5">
    <div class="row">
      <div class="col-12">
        <h2 class="mb-3"><b>Calculator - Free Software Design & Development Cost Estimate</b></h2>
        <p>Getting a software or application developed can be an overwhelming and dauting task. It requires financial and time
          investment and there is also a concern of going over time and budget estimates.</p>
        <p>This free software cost estimate calculator only provides approximate cost of your next project. Please note that this tool
          is only to assist you in getting an idea about the project cost.</p>
        <p>For more accurate estimates, we highly recommend market research and product discovery which is usually a 3-4 weeks
          activity. Please fill up the form for further information. Our estimates, offers and services are transparent and without any
          hidden obligations.</p>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
        <p><strong>What are you interested in?</strong></p>
        <div class="">
          <select class="form-control" style="width: 410px" [(ngModel)]="calculatorType" (change)="changeCalculatorType()">
            <option value="1">Business Website</option>
            <option value="2">E-Commerce & Market Place Websites</option>
            <option value="3">Mobile Apps</option>
            <option value="4">Web Applications</option>
          </select>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
<!--        <img src="assets/images/IrvineTek%20-%20Digital%20Marketing.jpg" class="img-fluid" alt="Analytics">-->
      </div>
    </div>


    <div class="row mt-4">
      <div class="col-sm-6 col-12">
        <div class="row">
          <div class="col-12" *ngIf="calculatorType === '1'">

            <div>
              <dl class="radio-list-left">
                <p><strong>Type of website:</strong></p>
                <dd>
                  <input type="radio" name="pq1" id="type1-1" value="1" checked="checked" (change)="updateTypeWeb($event.target.value)">
                  <label for="type1-1">Static</label>
                  <div class="heading-details">Content e.g., text, images cannot be changed without developer</div>
                </dd>
                <dd>
                  <input type="radio" name="pq1" id="type1-2" value="2"  (change)="updateTypeWeb($event.target.value)">
                  <label for="type1-2">Dynamic</label>
                  <span class="heading-details">Content can be changed at will (e.g., profile image in Facebook)</span>
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="radio-list-left">
                <p><strong>Size of Website:</strong></p>
                <dd>
                  <input type="radio" name="sizeWeb" value="1" id="size1-1" checked="checked" (change)="updateSizeWeb($event.target.value)">
                  <label for="size1-1">1</label>
                  <div class="heading-details">e.g., profile webPage</div>
                </dd>
                <dd>
                  <input type="radio" name="sizeWeb" value="2" id="size1-2" (change)="updateSizeWeb($event.target.value)">
                  <label for="size1-2">2-4</label>
                  <span class="heading-details">Small businesses with services & products</span>
                </dd>
                <dd>
                  <input type="radio" name="sizeWeb" value="3" id="size1-3" (change)="updateSizeWeb($event.target.value)">
                  <label for="size1-3">5-8</label>
                  <span class="heading-details">Medium size businesses offering services, products in multiple categories</span>
                </dd>
                <dd>
                  <input type="radio" name="sizeWeb" value="4" id="size1-4" (change)="updateSizeWeb($event.target.value)">
                  <label for="size1-4">9+</label>
                  <span class="heading-details">Market place websites</span>
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="check-list-left">
                <dt>Features:</dt>

                <dd>
                  <input type="checkbox" name="pq2" id="fw-1" value="200" (change)="featuresWeb($event.target)">
                  <label for="fw-1">Contact form</label>
                </dd>
                <dd>
                  <input type="checkbox" name="pq2" id="fw-2" value="200" (change)="featuresWeb($event.target)">
                  <label for="fw-2">Payment Gateway</label>
                </dd>
                <dd>
                  <input type="checkbox" name="fw3" id="fw-3" value="300" (change)="featuresWeb($event.target)">
                  <label for="fw-3">Customer portal</label>
                </dd>
                <dd>
                  <input type="checkbox" name="fw4" id="fw-4" value="200" (change)="featuresWeb($event.target)">
                  <label for="fw-4">Blogs</label>
                </dd>
                <dd>
                  <input type="checkbox" name="fw5" id="fw-5" value="200" (change)="featuresWeb($event.target)">
                  <label for="fw-5">Messaging/ Chat</label>
                </dd>
                <dd>
                  <input type="checkbox" name="fw6" id="fw-6" value="300" (change)="featuresWeb($event.target)">
                  <label for="fw-6">Social Media Integration</label>
                </dd>
                <dd>
                  <input type="checkbox" name="fw7" id="fw-7" value="200" (change)="featuresWeb($event.target)">
                  <label for="fw-7">3rd party integration</label>
                </dd>
                <dd>
                  <input type="checkbox" name="fw8" id="fw-8" value="200" (change)="featuresWeb($event.target)">
                  <label for="fw-8">Admin Panel</label>
                </dd>
                <dd>
                  <input type="checkbox" name="fw9" id="fw-9" value="200" (change)="featuresWeb($event.target)">
                  <label for="fw-9">Cloud Setup</label>
                </dd>

              </dl>
            </div>

            <div class="mt-45">
              <dl class="check-list-left">
                <dt>Additional Services:</dt>

                <dd>
                  <input type="checkbox" name="adService" id="adService-1" value="100" (change)="adFeaturesWeb($event.target)">
                  <label for="adService-1">Logo Design</label>
                </dd>
                <dd>
                  <input type="checkbox" name="adService" id="adService-2" value="200" (change)="adFeaturesWeb($event.target)">
                  <label for="adService-2">Graphic design</label>
                </dd>
                <dd>
                  <input type="checkbox" name="adService" id="adService-3" value="100" (change)="adFeaturesWeb($event.target)">
                  <label for="adService-3">Content Writing</label>
                </dd>
                <dd>
                  <input type="checkbox" name="adService" id="adService-4" value="200" (change)="adFeaturesWeb($event.target)">
                  <label for="adService-4">SEO Readiness</label>
                </dd>

              </dl>
            </div>


            <div class="mt-45">
              <button class="btn btn-primary font-weight-bold py-2" style="width: 150px;background-color: #003c77;border-color: #033057" (click)="submitCost()" *ngIf="showCost === 0">Calculate</button>
              <button class="btn btn-primary font-weight-bold py-2" style="width: 150px;background-color: #003c77;border-color: #033057" (click)="submitCost()" *ngIf="showCost === 1">Recalculate</button>
              <div *ngIf="showCost === 2">
                <h3>Estimated Cost: ${{webPrice}}</h3>
              </div>
            </div>


          </div>

          <div class="col-12" *ngIf="calculatorType === '2'">

            <div>
              <dl class="radio-list-left">
                <p><strong>Type of website:</strong></p>
                <dd>
                  <input type="radio" name="pq1" id="mpType1-1" value="2000" checked="checked" (change)="updateMpTypeWeb($event.target.value)">
                  <label for="mpType1-1">E-Commerce</label>
                  <div class="heading-details">E-Commerce</div>
                </dd>
                <dd>
                  <input type="radio" name="pq1" id="mpType1-2" value="3000"  (change)="updateMpTypeWeb($event.target.value)">
                  <label for="mpType1-2">Market Place Website</label>
                  <span class="heading-details">Market Place Website</span>
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="radio-list-left">
                <p><strong>Size of Website:</strong></p>
                <dd>
                  <input type="radio" name="sizeWeb" value="1" id="mpSize1-1" checked="checked" (change)="updateMpSizeWeb($event.target.value)">
                  <label for="mpSize1-1">2-4</label>
                  <div class="heading-details">Small businesses with limited services or products</div>
                </dd>
                <dd>
                  <input type="radio" name="sizeWeb" value="2" id="mpSize1-2" (change)="updateMpSizeWeb($event.target.value)">
                  <label for="mpSize1-2">5-8</label>
                  <span class="heading-details">Medium size businesses offering services, products in multiple categories</span>
                </dd>
                <dd>
                  <input type="radio" name="sizeWeb" value="3" id="mpSize1-3" (change)="updateMpSizeWeb($event.target.value)">
                  <label for="mpSize1-3">9+</label>
                  <span class="heading-details">Multiple products, services etc.</span>
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="check-list-left">
                <dt>Features:</dt>

                <dd>
                  <input type="checkbox" name="mpF2" id="mpF-1" value="200" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-1">Contact form</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF2" id="mpF-2" value="200" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-2">Payment Gateway</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF3" id="mpF-3" value="300" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-3">Customer portal</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF4" id="mpF-4" value="200" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-4">Blogs</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF5" id="mpF-5" value="200" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-5">Messaging/ Chat</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF6" id="mpF-6" value="300" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-6">Social Media Integration</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF7" id="mpF-7" value="200" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-7">3rd party integration</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF8" id="mpF-8" value="200" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-8">Admin Panel</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF9" id="mpF-9" value="200" (change)="featuresMpWeb($event.target)">
                  <label for="mpF-9">Cloud Setup</label>
                </dd>

              </dl>
            </div>

            <div class="mt-45">
              <dl class="check-list-left">
                <dt>Additional Services:</dt>

                <dd>
                  <input type="checkbox" name="adService" id="mpAdService-1" value="100" (change)="adFeaturesMpWeb($event.target)">
                  <label for="mpAdService-1">Logo Design</label>
                </dd>
                <dd>
                  <input type="checkbox" name="adService" id="mpAdService-2" value="200" (change)="adFeaturesMpWeb($event.target)">
                  <label for="mpAdService-2">Graphic design</label>
                </dd>
                <dd>
                  <input type="checkbox" name="adService" id="mpAdService-3" value="100" (change)="adFeaturesMpWeb($event.target)">
                  <label for="mpAdService-3">Content Writing</label>
                </dd>
                <dd>
                  <input type="checkbox" name="adService" id="mpAdService-4" value="200" (change)="adFeaturesMpWeb($event.target)">
                  <label for="mpAdService-4">SEO Readiness</label>
                </dd>

              </dl>
            </div>

            <div class="mt-45">
              <button class="btn btn-primary font-weight-bold py-2" style="width: 150px;background-color: #003c77;border-color: #033057" (click)="submitCost()" *ngIf="showCost === 0">Calculate</button>
              <button class="btn btn-primary font-weight-bold py-2" style="width: 150px;background-color: #003c77;border-color: #033057" (click)="submitCost()" *ngIf="showCost === 1">Recalculate</button>
              <div *ngIf="showCost === 2">
                <h3>Estimated Cost: ${{mpPrice}}</h3>
              </div>
            </div>


          </div>

          <div class="col-12" *ngIf="calculatorType === '3'">

            <div>
              <dl class="radio-list-left">
                <p><strong>Type of Mobile Apps:</strong></p>
                <dd>
                  <input type="radio" name="mAType1" id="mAType1-1" value="200" checked="checked" (change)="updateMaType($event.target.value)">
                  <label for="mAType1-1">iOS or Android</label>
                  <div class="heading-details">iOS or Android</div>
                </dd>
                <dd>
                  <input type="radio" name="mAType1" id="mAType1-2" value="350"  (change)="updateMaType($event.target.value)">
                  <label for="mAType1-2">Native</label>
                  <span class="heading-details">Native</span>
                </dd>
                <dd>
                  <input type="radio" name="mAType1" id="mAType1-3" value="250"  (change)="updateMaType($event.target.value)">
                  <label for="mAType1-3">Hybrid</label>
                  <span class="heading-details">Hybrid</span>
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="radio-list-left">
                <p><strong>Primary Purpose:</strong></p>
                <dd>
                  <input type="radio" name="maPurpose" value="3" id="maPurpose-1" checked="checked" (change)="updatePurposeApp($event.target.value)">
                  <label for="maPurpose-1">E-commerce application</label>
                </dd>
                <dd>
                  <input type="radio" name="maPurpose" value="3" id="maPurpose-2" (change)="updatePurposeApp($event.target.value)">
                  <label for="maPurpose-2">Market place application</label>
                </dd>
                <dd>
                  <input type="radio" name="maPurpose" value="2" id="maPurpose-3" (change)="updatePurposeApp($event.target.value)">
                  <label for="maPurpose-3">Magazine, Blog app</label>
                </dd>
                <dd>
                  <input type="radio" name="maPurpose" value="3" id="maPurpose-4" (change)="updatePurposeApp($event.target.value)">
                  <label for="maPurpose-4">Social app</label>
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="radio-list-left">
                <p><strong>Service:</strong></p>
                <dd>
                  <input type="radio" name="maService" value="1" id="maService-1" checked="checked" (change)="updateServiceApp($event.target.value)">
                  <label for="maService-1">Design</label>
                  <!--              <div class="heading-details">Small businesses with limited services or products</div>-->
                </dd>
                <dd>
                  <input type="radio" name="maService" value="10" id="maService-2" (change)="updateServiceApp($event.target.value)">
                  <label for="maService-2">Development</label>
                  <!--              <span class="heading-details">Medium size businesses offering services, products in multiple categories</span>-->
                </dd>
                <dd>
                  <input type="radio" name="maService" value="10.5" id="maService-3" (change)="updateServiceApp($event.target.value)">
                  <label for="maService-3">Design & Development</label>
                  <!--              <span class="heading-details">Multiple products, services etc.</span>-->
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="radio-list-left">
                <p><strong>Size of App:</strong></p>
                <dd>
                  <input type="radio" name="maSize1" value="1" id="maSize1-1" checked="checked" (change)="updateMpSizeApp($event.target.value)">
                  <label for="maSize1-1">3 screens</label>
                  <!--              <div class="heading-details">Small businesses with limited services or products</div>-->
                </dd>
                <dd>
                  <input type="radio" name="maSize1" value="1.5" id="maSize1-2" (change)="updateMpSizeApp($event.target.value)">
                  <label for="maSize1-2">4-6 screens</label>
                  <!--              <span class="heading-details">Medium size businesses offering services, products in multiple categories</span>-->
                </dd>
                <dd>
                  <input type="radio" name="maSize1" value="2" id="maSize1-3" (change)="updateMpSizeApp($event.target.value)">
                  <label for="maSize1-3">7-10 screens</label>
                  <!--              <span class="heading-details">Multiple products, services etc.</span>-->
                </dd>
                <dd>
                  <input type="radio" name="maSize1" value="2.5" id="maSize1-4" (change)="updateMpSizeApp($event.target.value)">
                  <label for="maSize1-4">11+ screens</label>
                  <!--              <span class="heading-details">Multiple products, services etc.</span>-->
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="check-list-left">
                <dt>Features:</dt>

                <dd>
                  <input type="checkbox" name="mpF2" id="mAF-1" value="500" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-1">Account setup (Logins)</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF2" id="mAF-2" value="500" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-2">Payment Gateway</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF3" id="mAF-3" value="500" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-3">Video integration</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF4" id="mAF-4" value="200" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-4">Location – GPS</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF5" id="mAF-5" value="200" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-5">3rd party integration (maps)</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF6" id="mAF-6" value="400" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-6">Admin Panel</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF7" id="mAF-7" value="300" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-7">Messaging</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF8" id="mAF-8" value="300" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-8">Client/Customer Portals</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF9" id="mAF-9" value="300" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-9">Cloud Setup</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF9" id="mAF-10" value="400" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-10">Portfolio Website</label>
                </dd>
                <dd>
                  <input type="checkbox" name="mpF9" id="mAF-11" value="2000" (change)="adFeaturesApp($event.target)">
                  <label for="mAF-11">Website with app features</label>
                </dd>

              </dl>
            </div>


            <div class="mt-45">
              <button class="btn btn-primary font-weight-bold py-2" style="width: 150px;background-color: #003c77;border-color: #033057" (click)="submitCost()" *ngIf="showCost === 0">Calculate</button>
              <button class="btn btn-primary font-weight-bold py-2" style="width: 150px;background-color: #003c77;border-color: #033057" (click)="submitCost()" *ngIf="showCost === 1">Recalculate</button>
              <div *ngIf="showCost === 2">
                <h3>Estimated Cost: ${{maPrice}}</h3>
              </div>
            </div>


          </div>

          <div class="col-12" *ngIf="calculatorType === '4'">

            <div>
              <dl class="radio-list-left">
                <p><strong>Web Applications:</strong></p>
                <dd>
                  <input type="radio" name="webAppType1" id="webAppType1-1" value="2000" checked="checked" (change)="updateUpdateWebApp($event.target.value)">
                  <label for="webAppType1-1">Customized Solution for your own business</label>
                  <!--              <div class="heading-details">Customized Solution for your own business</div>-->
                </dd>
                <dd>
                  <input type="radio" name="webAppType1" id="webAppType1-2" value="5000"  (change)="updateUpdateWebApp($event.target.value)">
                  <label for="webAppType1-2">SAAS based product for your clients</label>
                  <!--              <span class="heading-details">Market Place Website</span>-->
                </dd>
              </dl>
            </div>


            <div class="mt-45">
              <dl class="radio-list-left">
                <p><strong>Approximate Users & Products</strong></p>
                <dd>
                  <input type="radio" name="webAppProduct" value="1" id="webAppProduct-1" checked="checked" (change)="updateWebAppProduct($event.target.value)">
                  <label for="webAppProduct-1">Less than 20</label>
                </dd>
                <dd>
                  <input type="radio" name="webAppProduct" value="1.2" id="webAppProduct-2" (change)="updateWebAppProduct($event.target.value)">
                  <label for="webAppProduct-2">Between 21 & 100</label>
                </dd>
                <dd>
                  <input type="radio" name="webAppProduct" value="1.5" id="webAppProduct-3" (change)="updateWebAppProduct($event.target.value)">
                  <label for="webAppProduct-3">Between 100-500</label>
                </dd>
                <dd>
                  <input type="radio" name="webAppProduct" value="2" id="webAppProduct-4" (change)="updateWebAppProduct($event.target.value)">
                  <label for="webAppProduct-4">Between 501-1000</label>
                </dd>
                <dd>
                  <input type="radio" name="webAppProduct" value="4" id="webAppProduct-5" (change)="updateWebAppProduct($event.target.value)">
                  <label for="webAppProduct-5">More than 1000</label>
                </dd>
              </dl>
            </div>

            <div class="mt-45">
              <dl class="check-list-left">
                <dt>Features:</dt>

                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-1" value="3" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-1">Inventory Management</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-2" value="3" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-2">Accounting</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-3" value="4" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-3">Finance</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-4" value="3" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-4">Human Resource</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-5" value="2" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-5">Payroll</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-6" value="3" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-6">Office administration</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-7" value="4" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-7">CRM</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-8" value="3" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-8">POS</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-9" value="1" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-9">Scheduling</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-10" value="1" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-10">Attendance</label>
                </dd>
                <dd>
                  <input type="checkbox" name="webAppFeature" id="webAppFeature-11" value="1" (change)="featuresWebApp($event.target)">
                  <label for="webAppFeature-11">Advanced Analytics</label>
                </dd>
                <dd>
                  <input type="checkbox" name="otherSystemIntegration" id="otherSystemIntegration-1" value="500" (change)="integrationWebApp($event.target)">
                  <label for="otherSystemIntegration-1">Integration with other system</label>
                </dd>

              </dl>
            </div>

            <div class="mt-45">
              <button class="btn btn-primary font-weight-bold py-2" style="width: 150px;background-color: #003c77;border-color: #033057" (click)="submitCost()" *ngIf="showCost === 0">Calculate</button>
              <button class="btn btn-primary font-weight-bold py-2" style="width: 150px;background-color: #003c77;border-color: #033057" (click)="submitCost()" *ngIf="showCost === 1">Recalculate</button>
              <div *ngIf="showCost === 2">
                <h3>Estimated Cost: ${{webAppPrice}}</h3>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12">
        <img src="../../../assets/images/Free-Software-Development-Estimate-IrvineTek.png" class="img-responsive" style="width: 100%">
      </div>
    </div>

    </div>
</section>
